<script lang="ts">
  import { Turnstile } from "svelte-turnstile"
  import { browser } from "$app/environment"

  interface Props {
    isExample?: boolean
    turnstileToken?: string | null
  }

  let { isExample = false, turnstileToken = $bindable(null) }: Props = $props()
  const siteKey = "0x4AAAAAAA60ysMg0GGLU0RU"

  // let isMobile = $state(false)

  // if (browser) {
  //   const checkMobile = () => {
  //     isMobile = window.innerWidth < 768 // Standard mobile breakpoint
  //   }

  //   // Initial check
  //   checkMobile()

  //   // Update on resize
  //   window.addEventListener("resize", checkMobile)
  // }
</script>

{#if isExample}
  <div class="flex justify-center pt-3">
    <img
      src="https://cf-assets.www.cloudflare.com/slt3lc6tev37/2atsfrGgvgOc3DZ91qMlKN/0412afa63e5fac20964377c70c1a9a17/turnstile_gif.gif"
      class="w-7/12"
      alt="Cloudflare Turnstile verification example"
    />
  </div>
{:else}
  <div class="flex justify-center my-4 pt-3">
    <Turnstile
      {siteKey}
      on:callback={(e) => {
        turnstileToken = e.detail.token
      }}
      on:error={() => {
        turnstileToken = null
      }}
      theme="light"
    />
  </div>
{/if}
